import { Component, ElementRef, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';

import { NotificacionApiService } from '../../../core/services/notificacion-api.service';

@Component({
    selector: 'app-contacto-flotante',
    templateUrl: './contacto-flotante.component.html',
    styleUrls: ['./contacto-flotante.component.scss'],
    standalone: false
})
export class ContactoFlotanteComponent implements OnInit {
  @ViewChild('someelementone') someElementOne: ElementRef = {} as ElementRef;;

  contacto!: FormGroup;
  submitted = false;
  mensaje: string = '';
  mensajeStyle: string = '';

  nombre:string = '';
  apellido:string = '';
  empresa:string = '';
  cargo:string = '';
  movil:string = '';
  correo:string = '';
  ubicacion:string = '';
  cotiza:string = '';
  descripcion:string = '';
  urlActual: string = '';

  constructor(private router: Router, private formBuilder: FormBuilder, private notificacionApiService: NotificacionApiService) {
    this.urlActual = window.location.pathname;


    console.log(this.urlActual);
  }

  ngOnInit(): void {
    this.contacto = this.formBuilder.group({
        nombre: ['', Validators.required],            
        apellido: ['', [Validators.required]],
        empresa: ['', Validators.required],
        movil: ['', Validators.required],
        cargo: ['', Validators.required],
        correo: ['', Validators.required],
        ubicacion: ['', Validators.required],
        cotiza: ['', Validators.required],
        descripcion: ['', Validators.required]
    });
  }

  get f() {return this.contacto.controls; }

  onSubmit() {
    this.submitted = true;
 
    if(this.contacto.invalid) {
      
    } else {
      this.notificacionApiService.postEnviaEmailContacto(
        (this.nombre + ' ' + this.apellido), 
        this.empresa, 
        this.cargo, 
        this.movil, 
        this.correo,
        this.ubicacion, 
        this.cotiza, 
        this.descripcion).subscribe(
        (data: []) => {
          // let _response: any = data;
          this.mensaje = 'Gracias por pornerte en contacto con nosotros.';
          this.mensajeStyle = 'success';
        },(error: {}) => {
          console.error("error");
          this.mensaje = 'Tenemos un problema con la notificación, por favor intenta mas tarde.';
          this.mensajeStyle = 'danger';
        }
      );  
    }
  }

  toogleContact() {
    this.removeClass(this.someElementOne, 'toggle-class-close');
    this.toggleClass(this.someElementOne, 'toggle-class-one');
  }

  toogleContactClose() {
    // this.removeClass(this.someElementOne, 'toggle-class-one');
    this.toggleClass(this.someElementOne, 'toggle-class-close');
  }

  toggleClass(eleRef: ElementRef, classStr: string) {
    eleRef.nativeElement.classList.toggle(classStr);
  }

  removeClass(eleRef: ElementRef, classStr: string) {
    eleRef.nativeElement.classList.remove(classStr);
  }

}
